import { formatSalesValue } from "../../../utils/formatUtils";

const ActualFoodCosting = ({ foodData, costAccuracy, actualAccuracy, formatNumber }) => {
    return (
        <div className="border p-2">
            <div className="font-semibold mb-2 text-lg text-center">ACTUAL FOOD COSTING</div>
            <div className="rounded-md border overflow-x-auto max-h-[400px]">
                <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Item Name</th>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">UOM</th>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Opening</th>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Closing</th>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Value</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                        {foodData?.items_actual_food_costing?.map((item, i) => (
                            <tr key={i} className="hover:bg-gray-50">
                                <td className="px-3 py-2">{item.item_name}</td>
                                <td className="px-3 py-2">{item.uom}</td>
                                <td className="px-3 py-2">{formatNumber(item.opening_count)}</td>
                                <td className="px-3 py-2">{formatNumber(item.physical_count)}</td>
                                <td className="px-3 py-2">
                                    OV={formatSalesValue(item.opening_cost)} : CV={formatSalesValue(item.physical_cost)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="mt-2 p-1 space-y-1">
                <div className='grid grid-cols-2 gap-28 font-semibol px-2 font-semibold'>
                    <div>
                        <div className="grid grid-cols-2 gap-2 items-center">
                            <label className="mr-2">Opening:</label>
                            <input
                                type="text"
                                readOnly
                                value={formatSalesValue(foodData?.summary?.total_opening_cost)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label className="mr-2">Closing:</label>
                            <input
                                type="text"
                                readOnly
                                value={formatSalesValue(foodData?.summary?.total_physical_cost)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label className="mr-2">Cost of Goods Sold:</label>
                            <input
                                type="text"
                                readOnly
                                value={formatSalesValue(foodData?.summary?.total_actual_consumption_cost)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2 items-center">
                        <label className="mr-2">Wastage:</label>
                        <input
                            type="text"
                            readOnly
                            value={formatSalesValue(foodData?.summary?.total_wastage_cost)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Discrepancies:</label>
                        <input
                            type="text"
                            readOnly
                            value={foodData?.summary?.total_discrepancy_cost}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Actual Food Cost%:</label>
                        <input
                            type="text"
                            readOnly
                            value={`${actualAccuracy} %`}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Cost Accuracy%:</label>
                        <input
                            type="text"
                            readOnly
                            value={`${costAccuracy.toFixed(2)} %`}
                            className={`border p-1 rounded w-full font-semibold text-center ${costAccuracy < 80
                                ? 'bg-red-200 text-red-800'
                                : costAccuracy >= 80 && costAccuracy <= 90 ? 'bg-yellow-200 text-yellow-800' :
                                    'bg-green-200 text-green-800'
                                }`}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActualFoodCosting